import { Injectable } from "@angular/core";
import Swal, { SweetAlertOptions } from "sweetalert2";

@Injectable({ providedIn: "root" })
export class AlertasSwalService {
  correcta(title: string, msg: string) {
  return  Swal.fire({
      icon: "success",
      title: title,
      text: msg,
    });
  }

  error(title: string, msg: string) {
    return Swal.fire({
      icon: "error",
      title: title,
      text: msg,
    });
  }

  ask(options: SweetAlertOptions) {
    return Swal.fire(options);
  }
}
